import {
  ASSET_ITEM_NAME,
  ASSET_LIST_NAME,
  CREATE_ASSET_TASK_NAME,
  CREATE_PROJECT_TASK_NAME,
  CREATE_TEMPLATE_TASK_NAME,
  PROJECT_ITEM_NAME,
  PROJECT_LIST_NAME,
  TEMPLATE_ITEM_NAME,
  TEMPLATE_LIST_NAME,
  UPDATE_ASSET_TASK_NAME,
  UPDATE_PROJECT_TASK_NAME,
  UPDATE_TEMPLATE_TASK_NAME,
} from '../redux/state';


/**
 * CODE_TAG[Global-state-shape-aware]
 * @param rootState
 * @return {*}
 */
export function getState(rootState) {
  return rootState.tasks;
}

export function getAssetTask(rootState) {
  return getState(rootState)[ASSET_ITEM_NAME];
}

export function getProjectTask(rootState) {
  return getState(rootState)[PROJECT_ITEM_NAME];
}

export function getTemplateTask(rootState) {
  return getState(rootState)[TEMPLATE_ITEM_NAME];
}

export function getAssetTasks(rootState) {
  return getState(rootState)[ASSET_LIST_NAME];
}

export function getProjectTasks(rootState) {
  return getState(rootState)[PROJECT_LIST_NAME];
}

export function getTemplateTasks(rootState) {
  return getState(rootState)[TEMPLATE_LIST_NAME];
}

export function getCreateAssetTask(rootState) {
  return getState(rootState)[CREATE_ASSET_TASK_NAME];
}

export function getCreateProjectTask(rootState) {
  return getState(rootState)[CREATE_PROJECT_TASK_NAME];
}

export function getCreateTemplateTask(rootState) {
  return getState(rootState)[CREATE_TEMPLATE_TASK_NAME];
}

export function getUpdateAssetTask(rootState) {
  return getState(rootState)[UPDATE_ASSET_TASK_NAME];
}

export function getUpdateProjectTask(rootState) {
  return getState(rootState)[UPDATE_PROJECT_TASK_NAME];
}

export function getUpdateTemplateTask(rootState) {
  return getState(rootState)[UPDATE_TEMPLATE_TASK_NAME];
}



// WEBPACK FOOTER //
// ./src/js/tasks/reducers/state.js